// @ts-nocheck
import {useEffect, useRef} from 'react'
import {
  drawFirework,
  FireworkState,
  initialiseFirework,
  random,
  updateFirework,
} from '@/components/Modals/Firework/Model/Firework'

interface Firework {
  x: number
  y: number
  size: number
  speedX: number
  speedY: number
  alpha: number
}

const Index = ({hide}: {hide: () => void}) => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null)
  const endRef = useRef<boolean>(false)

  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) {
      return
    }

    const ctx = canvas.getContext('2d')
    if (!ctx) {
      return
    }

    canvas.width = window.innerWidth
    canvas.height = window.innerHeight

    const state: FireworkState = {
      context: canvas.getContext('2d'),
      height: canvas.height,
      width: canvas.width,
      hue: 120,
      fireworks: [],
    }
    state.fireworks = createFireworks(
      10,
      canvas.height,
      canvas.width,
      state.hue
    )
    state.fireworks = [
      ...state.fireworks,
      ...createFireworks(10, canvas.height, canvas.width, state.hue, true),
    ]

    const loop = () => {
      state.hue = random(0, 360)

      const context = state.context
      context.globalCompositeOperation = 'destination-out'

      context.fillStyle = 'rgba(0, 0, 0, 0.5)'
      context.fillRect(0, 0, state.width, state.height)

      context.globalCompositeOperation = 'lighter'

      let i = state.fireworks.length
      while (i--) {
        const firework: Firework = state.fireworks[i]

        drawFirework(state.context, firework, state.hue)

        updateFirework(firework, state, i)
      }

      window.requestAnimationFrame(() => {
        if (!endRef.current) {
          loop()
        }
      })
    }
    loop()

    return () => {
      endRef.current = true
    }
  }, [])

  return (
    <canvas
      ref={canvasRef}
      onClick={hide}
      style={{
        backgroundColor: 'transparent',
        position: 'fixed',
        pointerEvents: 'none',
        top: 0,
        left: 0,
      }}
    />
  )
}

const createFireworks = (
  count: number,
  height: number,
  width: number,
  hue: number,
  isLeft = false
): Firework[] => {
  const fireworks: Firework[] = []
  for (let i = 0; i <= count; i++) {
    fireworks.push(
      initialiseFirework(
        {x: isLeft ? 0 : width, y: height},
        {x: random(0, width), y: random(0, height / 2)},
        hue
      )
    )
  }
  return fireworks
}

export default Index
